
import { defineComponent } from "vue";
import { useStore } from "vuex";
import axios from "axios";

export default defineComponent({
  components: {},
  props: {
    disable: Boolean,
    getReactiveImageData: Array,
  },
  setup(props) {
    const store = useStore();

    const sendImageData = () => {
      axios
        .post("https://httpbin.org/post", props.getReactiveImageData)
        .then((res) => {
          console.log(res.data.json); //コンソールデバック用に設置
          store.commit("setCode", res.status);
        })
        .catch((error) => {
          store.commit("setCode", error.response.status);
        })
        .finally(() => {
          if (store.state.code !== (200 || null)) {
            alert(`${store.state.code}番エラーが発生しました`);
          }
        });
    };
    return { sendImageData };
  },
});
